import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Facebook, Youtube } from 'lucide-react';
import { useSiteSettings } from '../hooks/useSiteSettings';

const corporateLinks = [
  { label: 'Hakkımızda', to: '/hakkimizda' },
  { label: 'Blog', to: '/blog' },
  { label: 'Takvim', to: '/takvim' },
  { label: 'Grup Rezervasyonu', to: '/grup-rezervasyonu' },
  { label: 'Bize Ulaşın', to: '/bize-ulasin' },
  { label: 'Yardım ve SSS', to: '/yardim-ve-sss' },
  { label: 'Mesafeli Satış Sözleşmesi', to: '/mesafeli-satis-sozlesmesi' },
  { label: 'İptal Politikası', to: '/iptal-politikasi' },
  { label: 'KVKK Aydınlatma Metni', to: '/kvkk' },
];

const Footer = () => {
  const settings = useSiteSettings();
  const socials = [
    { url: settings.instagram, Icon: Instagram, label: 'Instagram' },
    { url: settings.twitter,   Icon: Twitter,   label: 'Twitter' },
    { url: settings.facebook,  Icon: Facebook,  label: 'Facebook' },
    { url: settings.youtube,   Icon: Youtube,   label: 'YouTube' },
  ].filter(s => s.url);
  return (
    <footer className="bg-[#1B1B1B] text-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="mb-12">
          <h4
            className="text-xs font-semibold uppercase tracking-[0.15em] text-white/60 mb-5"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Kurumsal
          </h4>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3 max-w-3xl">
            {corporateLinks.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.to.replace(/\//g, '')}`}
                  className="text-sm text-white/75 hover:text-white transition-colors duration-200"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <svg width="30" height="30" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="Camption" role="img">
              <circle cx="32" cy="32" r="22" fill="none" stroke="#F6F4EC" strokeWidth="8" strokeLinecap="round" strokeDasharray="104 138" transform="rotate(38 32 32)"/>
              <circle cx="32" cy="32" r="6" fill="#D9A57F"/>
            </svg>
            <span
              className="text-lg text-[#F6F4EC]"
              style={{ fontFamily: "'Archivo', Helvetica, Arial, sans-serif", fontWeight: 500, letterSpacing: '0.12em' }}
            >
              CAMPTION
            </span>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            {socials.length === 0 ? null : socials.map(({ url, Icon, label }) => (
              <a
                key={label}
                href={url}
                target="_blank"
                rel="noreferrer"
                className="p-2 hover:bg-white/10 rounded-full transition-colors"
                aria-label={label}
              >
                <Icon size={18} className="text-white/60 hover:text-white" />
              </a>
            ))}
          </div>

          {/* Copyright */}
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Camption Tüm hakları saklıdır.
          </p>
        </div>

        {/* TÜRSAB Dijital Doğrulama */}
        <div className="mt-10 pt-8 border-t border-white/10 flex justify-center">
          <a
            href="https://www.tursab.org.tr/tr/ddsv"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="tursab-dds-link"
            className="inline-block hover:opacity-90 transition-opacity"
            aria-label="TÜRSAB Dijital Doğrulama Sistemi - Belge No: 13653"
          >
            <img
              src="/tursab-dds-13653.png"
              alt="TÜRSAB Dijital Doğrulama Sistemi - Belge No: 13653"
              loading="lazy"
              className="h-auto"
              style={{ maxWidth: '200px' }}
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
